import type { Position } from "./types";

export const DEFAULT_OFFSET = 6;

export const POSITIONS = [
  "top",
  "top-end",
  "top-start",
  "right",
  "right-end",
  "right-start",
  "bottom",
  "bottom-end",
  "bottom-start",
  "left",
  "left-end",
  "left-start",
] as const;

export const DEFAULT_POSITION = "top" satisfies Position;

export const FLIP_PADDING = 5;
export const SHIFT_PADDING = 5;
export const ARROW_PADDING = 15;
